import { useCallback, useMemo } from "react";
import { Icon } from "../../../components/icons/Icon";
import { blankIcon } from "../../../components/icons/appIcons";

/**
 * SettingsSelect
 * Renders a <select> for settings with discrete string options (e.g. theme-mode: light/dark/auto).
 *
 * Props:
 * - item: { id, value, label, description, options? }
 *   where options can be ["light","dark","auto"] or [{ value:"light", label:"Light"}, ...]
 * - onSettingChange: (nextItem) => void // parent persists with repo.put(nextItem)
 * - id?: string
 * - disabled?: boolean
 * - className?: string
 */
export function SettingsSelect({
  setting,
  onSettingChange,
  id,
  disabled = false,
  className = "",
}) {
  const {
    id: settingKey,
    value,
    label = "",
    description = "",
    options = [],
  } = setting;

  //   const normalized = useMemo(
  //     () =>
  //       setting.options.map((opt) =>
  //         typeof opt === "string" ? { value: opt, label: opt } : opt
  //       ),
  //     [setting.options]
  //   );
  const normalized = useMemo(() => {
    const out = [];
    for (const opt of options || []) {
      const k = Object.keys(opt)[0]; // Get the first (and only) key of the object
      const v = opt[k];
      //   const [k, v] = Object.entries(opt)[0] || ["", ""];
      out.push({ value: k, label: v });
    }
    return out;
  }, [options]);

  const handleChange = useCallback(
    (e) => {
      const nextValue = e.target.value;
      const nextItem = { ...setting, value: nextValue };
      onSettingChange?.(nextItem);
    },
    [setting, onSettingChange]
  );

  const inputId = id || `setting-${settingKey}`;

  return (
    <label htmlFor={inputId}>
      <select
        id={inputId}
        value={value ?? ""}
        onChange={handleChange}
        disabled={disabled}
      >
        {normalized.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}
